module.exports = __webpack_public_path__ + "static/media/040-traffic-light.0ff9b247.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/040-traffic-light.svg
// module id = 208
// module chunks = 0